import React from "react";
import { getCardImage } from "../resultVisuals/cardAssets";
import { formatRangeVal } from "./refUtils";
import Collapse from "../../../components/Collapse";
import CardImg from "../../../components/CardImg";

/** Shared components of the reference markup for the poker cluster (teen8 / poker / poker6). */

// Reference <Card>: <span><img src="cards/{card}.png"></span> ("1" = card back)
export function RefCard({ card }) {
  return (
    <span>
      <CardImg src={getCardImage(card)} alt="" />
    </span>
  );
}

/** Bootstrap-collapse range popup: <i data-toggle="collapse"> + <div class="collapse icon-range">R:min-max</div> */
export function RangeIcon({ id, market, open, onToggle, iconClass = "fas fa-info-circle", attrOrder = "toggle-first" }) {
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onToggle(id);
  };
  const icon =
    attrOrder === "target-first" ? (
      <i data-target={`#${id}`} data-toggle="collapse" className={iconClass} onClick={onClick} />
    ) : (
      <i data-toggle="collapse" data-target={`#${id}`} className={iconClass} onClick={onClick} />
    );
  return (
    <>
      {icon}{" "}
      <Collapse id={id} open={!!open} className="icon-range">
        {"\n                      R:"}
        <span>{formatRangeVal(market?.min)}</span>-<span>{formatRangeVal(market?.max)}</span>
      </Collapse>
    </>
  );
}
